import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { CheckCircle2, Loader2, Lock, Mail, Phone } from 'lucide-react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '../components/ui/dialog';
import { api, errMsg } from './api';
import { goldBtn } from './ui';
import { usePortal } from './PortalAuth';
import { NAV, sectionOf } from './shells/nav';
import { SERVICE_INFO } from './serviceInfo';

function ServiceLocked({ id }) {
  const item = NAV.find((n) => n.id === id);
  const [state, setState] = useState('idle');
  const request = async () => {
    setState('busy');
    try { await api.post('/requests/service-activation', { service: id, label: item?.label }); setState('sent'); } catch (e) { toast.error(errMsg(e)); setState('idle'); }
  };
  const Icon = item?.icon || Lock;
  return (
    <div className="relative min-h-[60vh]" data-testid="service-locked">
      <div className="pointer-events-none select-none blur-[3px] opacity-50" aria-hidden="true">
        <p className="text-[11px] uppercase tracking-[0.25em] text-[#D4AF37] mb-2">Servizio</p><h1 className="font-heading text-4xl text-[#F2F2F2] mb-8">{item?.label}</h1>
        <div className="grid sm:grid-cols-3 gap-4">{[1, 2, 3].map((i) => <div key={i} className="portal-card h-40" />)}</div>
      </div>
      <Dialog open modal={false}>
        <DialogContent className="design-dialog max-w-lg [&>button]:hidden" data-testid="service-locked-dialog" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
          <div className="w-11 h-11 rounded-full grid place-items-center bg-[#D4AF37]/15 text-[#D4AF37]"><Icon size={20} /></div>
          <DialogTitle className="font-heading text-2xl leading-tight" data-testid="service-locked-title">{item?.label}</DialogTitle>
          <DialogDescription asChild>
            <div className="text-sm opacity-85 space-y-3 -mt-1 leading-relaxed">
              <p data-testid="service-locked-text">{SERVICE_INFO[id]}</p>
              <p className="text-xs opacity-80">Il servizio non è ancora attivo sul tuo account: richiedi l'attivazione e Smart Info ti contatterà con le condizioni.</p>
            </div>
          </DialogDescription>
          <div className="grid sm:grid-cols-2 gap-2 text-sm">
            <a href="mailto:info@smart-info.it" className="flex items-center gap-2 px-3 py-2.5 border border-[#1F242C] rounded-sm hover:border-[#D4AF37]" data-testid="service-locked-email"><Mail size={15} className="text-[#D4AF37]" />info@smart-info.it</a>
            <a href="tel:800778055" className="flex items-center gap-2 px-3 py-2.5 border border-[#1F242C] rounded-sm hover:border-[#D4AF37]" data-testid="service-locked-phone"><Phone size={15} className="text-[#D4AF37]" />Numero Verde 800 778 055</a>
          </div>
          {state === 'sent'
            ? <p className="flex items-center gap-2 text-sm text-[#5FC18F]" data-testid="service-locked-sent"><CheckCircle2 size={16} />Richiesta inviata: Smart Info ti contatterà a breve.</p>
            : <div><button onClick={request} disabled={state === 'busy'} className={`${goldBtn} h-11 px-6 text-sm inline-flex items-center gap-2`} data-testid="service-locked-request">{state === 'busy' && <Loader2 size={15} className="animate-spin" />}Richiedi attivazione</button></div>}
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default function ServiceGate({ ctx }) {
  const { user } = usePortal();
  const { pathname } = useLocation();
  const id = sectionOf(pathname);
  if (id && (user?.services_disabled || []).includes(id)) return <ServiceLocked key={id} id={id} />;
  return <Outlet context={ctx} />;
}
